import axios from "axios";
import { BASEDOMAIN } from "@/constants/allconstants";
import { AuthConfig } from "@/utils/constants/configContants";
import { getToken } from "@/utils/functions/TokenFunction";

export const fetchStats = async (callback: any, errorCallback: any) => {
    await axios.get(`${BASEDOMAIN}/stats`, {
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${getToken()}`,
            },
        })
        .then((response: any) => {
            callback(response?.data);
        })
        .catch((e: any) => errorCallback(e?.response?.data));
};
